import { CardPaymentGroupActions, CardPaymentMethodData, CardPaymentMethodMeta } from "./Card";
import { CodPaymentMethodData, TURBO_COD_CONFIRM_HALF_CARD_TYPE, TurboCodPaymentMethodMeta } from "./Cod";
import { InAppUpiPaymentGroupActions, InAppUpiPaymentMethod, InAppUpiPaymentMethodMeta } from "./InAppUpi";
import { PaymentGroupActions } from "./Payment";
import {
    SwiggyInstrumentsMeta,
    SwiggyInstrumentsPaymentGroupActions,
    SwiggyInstrumentsPaymentMethodData,
} from "./SwiggyInstruments";
import { UpiPaymentGroupActions, UpiPaymentMethod, UpiPaymentMethodMeta } from "./Upi";
import { WalletPaymentGroupActions, WalletPaymentMethodData, WalletPaymentMethodMeta } from "./Wallet";

import { CredEligibleData } from "./CredPay";
//internal-deps
import { ITypography } from "@swiggy-private/dls-web-common/dist/components/types";
import { B2CPaymentMethodData } from "./BillToCompany";
import { TurboStripEventAction, TurboStripData } from "@swiggy-private/core-ui";
import { IColorMode } from "@swiggy-private/dls-web-common/dist/components/types";

export type TurboPaymentSpecificActions =
    | (
          | UpiPaymentGroupActions
          | CardPaymentGroupActions
          | WalletPaymentGroupActions
          | SwiggyInstrumentsPaymentGroupActions
          | InAppUpiPaymentGroupActions
          | PaymentGroupActions<CodPaymentMethodData>
      )
    | undefined;
export type TurboPaymentMethodMeta =
    | UpiPaymentMethodMeta
    | CardPaymentMethodMeta
    | WalletPaymentMethodMeta
    | SwiggyInstrumentsMeta
    | TurboCodPaymentMethodMeta
    | InAppUpiPaymentMethodMeta;

export type TurboPaymentMethod =
    | UpiPaymentMethod
    | CardPaymentMethodData
    | WalletPaymentMethodData
    | SwiggyInstrumentsPaymentMethodData
    | CodPaymentMethodData
    | InAppUpiPaymentMethod
    | B2CPaymentMethodData;

export type TurboAutoPayMethod = CodPaymentMethodData;

export interface PaymentMethodDowntime {
    singleClickPresentationInfo: {
        title: string;
        subtitle: string;
        icon: string;
    };
    paymentPageHalfcardPlaceholders: {
        paymentMethodDisplayName: string;
    };
}

export type TurboPayOfferComms = {
    showTooltip: boolean;
    toolTipText: string;
};

export interface TurboCommsConfig {
    text: string;
    commsDataTestId: string;
    textVariant: keyof ITypography;
}

export enum TurboPaymentCommsType {
    EDU_COMMS = "eduComms",
    OFFER_COMMS = "offerComms",
}

export interface TurboPodHalfCardEvents {
    onLoad: (type: TURBO_COD_CONFIRM_HALF_CARD_TYPE) => void;
    onPlaceOrderCtaClick: (flow: TURBO_COD_CONFIRM_HALF_CARD_TYPE, isSliderCompleted?: "yes" | "no") => void;
    onCancelCtaClick: (flow: TURBO_COD_CONFIRM_HALF_CARD_TYPE) => void;
}

export interface ITurboPaymentMethodProps {
    methodData: TurboPaymentMethod;
    paymentActions: PaymentGroupActions<TurboPaymentMethod>;
    onClickChangePaymentCta: VoidFunction;
    turboPaymentCtaMeta?: {
        amountWithDiscount: string;
        amountWithoutDiscount?: string;
        mainText: string;
        subText: string;
    };
    showDiscountedAmount: boolean;
    balanceValue?: string | number; // for wallets + swiggy-money + upi lite
    credEligibleData?: CredEligibleData; // for cred
    turboPodHalfCardEvents: TurboPodHalfCardEvents;
    increaseSliderWidth: boolean;
    isTurboV2?: boolean;
    isPopCart?: boolean;
    onClickTurboStrip?: TurboStripEventAction;
    onImpressionTurboStrip?: TurboStripEventAction;
    turboStrip?: TurboStripData;
    isBillToCompanyExist?: boolean;
    clampDiscountText?: boolean;
    /** This is to handle the color only for scenes mode for the turbo payment */
    forceColorMode?: IColorMode;
    onCvvPopupOpen?: VoidFunction;
    keyFactStatementUrl?: string;
    onKeyFactStatementClick?: (url: string) => void;
}
